/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createTickets = /* GraphQL */ `
  mutation CreateTickets(
    $input: CreateTicketsInput!
    $condition: ModelTicketsConditionInput
  ) {
    createTickets(input: $input, condition: $condition) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTickets = /* GraphQL */ `
  mutation UpdateTickets(
    $input: UpdateTicketsInput!
    $condition: ModelTicketsConditionInput
  ) {
    updateTickets(input: $input, condition: $condition) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTickets = /* GraphQL */ `
  mutation DeleteTickets(
    $input: DeleteTicketsInput!
    $condition: ModelTicketsConditionInput
  ) {
    deleteTickets(input: $input, condition: $condition) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTicketStatus = /* GraphQL */ `
  mutation CreateTicketStatus(
    $input: CreateTicketStatusInput!
    $condition: ModelTicketStatusConditionInput
  ) {
    createTicketStatus(input: $input, condition: $condition) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTicketStatus = /* GraphQL */ `
  mutation UpdateTicketStatus(
    $input: UpdateTicketStatusInput!
    $condition: ModelTicketStatusConditionInput
  ) {
    updateTicketStatus(input: $input, condition: $condition) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTicketStatus = /* GraphQL */ `
  mutation DeleteTicketStatus(
    $input: DeleteTicketStatusInput!
    $condition: ModelTicketStatusConditionInput
  ) {
    deleteTicketStatus(input: $input, condition: $condition) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNotificaciones = /* GraphQL */ `
  mutation CreateNotificaciones(
    $input: CreateNotificacionesInput!
    $condition: ModelNotificacionesConditionInput
  ) {
    createNotificaciones(input: $input, condition: $condition) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotificaciones = /* GraphQL */ `
  mutation UpdateNotificaciones(
    $input: UpdateNotificacionesInput!
    $condition: ModelNotificacionesConditionInput
  ) {
    updateNotificaciones(input: $input, condition: $condition) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotificaciones = /* GraphQL */ `
  mutation DeleteNotificaciones(
    $input: DeleteNotificacionesInput!
    $condition: ModelNotificacionesConditionInput
  ) {
    deleteNotificaciones(input: $input, condition: $condition) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createNotificacionesNuevas = /* GraphQL */ `
  mutation CreateNotificacionesNuevas(
    $input: CreateNotificacionesNuevasInput!
    $condition: ModelNotificacionesNuevasConditionInput
  ) {
    createNotificacionesNuevas(input: $input, condition: $condition) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateNotificacionesNuevas = /* GraphQL */ `
  mutation UpdateNotificacionesNuevas(
    $input: UpdateNotificacionesNuevasInput!
    $condition: ModelNotificacionesNuevasConditionInput
  ) {
    updateNotificacionesNuevas(input: $input, condition: $condition) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteNotificacionesNuevas = /* GraphQL */ `
  mutation DeleteNotificacionesNuevas(
    $input: DeleteNotificacionesNuevasInput!
    $condition: ModelNotificacionesNuevasConditionInput
  ) {
    deleteNotificacionesNuevas(input: $input, condition: $condition) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProducto = /* GraphQL */ `
  mutation CreateProducto(
    $input: CreateProductoInput!
    $condition: ModelProductoConditionInput
  ) {
    createProducto(input: $input, condition: $condition) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProducto = /* GraphQL */ `
  mutation UpdateProducto(
    $input: UpdateProductoInput!
    $condition: ModelProductoConditionInput
  ) {
    updateProducto(input: $input, condition: $condition) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProducto = /* GraphQL */ `
  mutation DeleteProducto(
    $input: DeleteProductoInput!
    $condition: ModelProductoConditionInput
  ) {
    deleteProducto(input: $input, condition: $condition) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCliente = /* GraphQL */ `
  mutation CreateCliente(
    $input: CreateClienteInput!
    $condition: ModelClienteConditionInput
  ) {
    createCliente(input: $input, condition: $condition) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCliente = /* GraphQL */ `
  mutation UpdateCliente(
    $input: UpdateClienteInput!
    $condition: ModelClienteConditionInput
  ) {
    updateCliente(input: $input, condition: $condition) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCliente = /* GraphQL */ `
  mutation DeleteCliente(
    $input: DeleteClienteInput!
    $condition: ModelClienteConditionInput
  ) {
    deleteCliente(input: $input, condition: $condition) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createClienteContactos = /* GraphQL */ `
  mutation CreateClienteContactos(
    $input: CreateClienteContactosInput!
    $condition: ModelClienteContactosConditionInput
  ) {
    createClienteContactos(input: $input, condition: $condition) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateClienteContactos = /* GraphQL */ `
  mutation UpdateClienteContactos(
    $input: UpdateClienteContactosInput!
    $condition: ModelClienteContactosConditionInput
  ) {
    updateClienteContactos(input: $input, condition: $condition) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteClienteContactos = /* GraphQL */ `
  mutation DeleteClienteContactos(
    $input: DeleteClienteContactosInput!
    $condition: ModelClienteContactosConditionInput
  ) {
    deleteClienteContactos(input: $input, condition: $condition) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProveedores = /* GraphQL */ `
  mutation CreateProveedores(
    $input: CreateProveedoresInput!
    $condition: ModelProveedoresConditionInput
  ) {
    createProveedores(input: $input, condition: $condition) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProveedores = /* GraphQL */ `
  mutation UpdateProveedores(
    $input: UpdateProveedoresInput!
    $condition: ModelProveedoresConditionInput
  ) {
    updateProveedores(input: $input, condition: $condition) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProveedores = /* GraphQL */ `
  mutation DeleteProveedores(
    $input: DeleteProveedoresInput!
    $condition: ModelProveedoresConditionInput
  ) {
    deleteProveedores(input: $input, condition: $condition) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createProveedorContactos = /* GraphQL */ `
  mutation CreateProveedorContactos(
    $input: CreateProveedorContactosInput!
    $condition: ModelProveedorContactosConditionInput
  ) {
    createProveedorContactos(input: $input, condition: $condition) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateProveedorContactos = /* GraphQL */ `
  mutation UpdateProveedorContactos(
    $input: UpdateProveedorContactosInput!
    $condition: ModelProveedorContactosConditionInput
  ) {
    updateProveedorContactos(input: $input, condition: $condition) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteProveedorContactos = /* GraphQL */ `
  mutation DeleteProveedorContactos(
    $input: DeleteProveedorContactosInput!
    $condition: ModelProveedorContactosConditionInput
  ) {
    deleteProveedorContactos(input: $input, condition: $condition) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createICuarentena = /* GraphQL */ `
  mutation CreateICuarentena(
    $input: CreateICuarentenaInput!
    $condition: ModelICuarentenaConditionInput
  ) {
    createICuarentena(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateICuarentena = /* GraphQL */ `
  mutation UpdateICuarentena(
    $input: UpdateICuarentenaInput!
    $condition: ModelICuarentenaConditionInput
  ) {
    updateICuarentena(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteICuarentena = /* GraphQL */ `
  mutation DeleteICuarentena(
    $input: DeleteICuarentenaInput!
    $condition: ModelICuarentenaConditionInput
  ) {
    deleteICuarentena(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUbicacion = /* GraphQL */ `
  mutation CreateUbicacion(
    $input: CreateUbicacionInput!
    $condition: ModelUbicacionConditionInput
  ) {
    createUbicacion(input: $input, condition: $condition) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUbicacion = /* GraphQL */ `
  mutation UpdateUbicacion(
    $input: UpdateUbicacionInput!
    $condition: ModelUbicacionConditionInput
  ) {
    updateUbicacion(input: $input, condition: $condition) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUbicacion = /* GraphQL */ `
  mutation DeleteUbicacion(
    $input: DeleteUbicacionInput!
    $condition: ModelUbicacionConditionInput
  ) {
    deleteUbicacion(input: $input, condition: $condition) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createReciba = /* GraphQL */ `
  mutation CreateReciba(
    $input: CreateRecibaInput!
    $condition: ModelRecibaConditionInput
  ) {
    createReciba(input: $input, condition: $condition) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateReciba = /* GraphQL */ `
  mutation UpdateReciba(
    $input: UpdateRecibaInput!
    $condition: ModelRecibaConditionInput
  ) {
    updateReciba(input: $input, condition: $condition) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteReciba = /* GraphQL */ `
  mutation DeleteReciba(
    $input: DeleteRecibaInput!
    $condition: ModelRecibaConditionInput
  ) {
    deleteReciba(input: $input, condition: $condition) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecibaSeriales = /* GraphQL */ `
  mutation CreateRecibaSeriales(
    $input: CreateRecibaSerialesInput!
    $condition: ModelRecibaSerialesConditionInput
  ) {
    createRecibaSeriales(input: $input, condition: $condition) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecibaSeriales = /* GraphQL */ `
  mutation UpdateRecibaSeriales(
    $input: UpdateRecibaSerialesInput!
    $condition: ModelRecibaSerialesConditionInput
  ) {
    updateRecibaSeriales(input: $input, condition: $condition) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecibaSeriales = /* GraphQL */ `
  mutation DeleteRecibaSeriales(
    $input: DeleteRecibaSerialesInput!
    $condition: ModelRecibaSerialesConditionInput
  ) {
    deleteRecibaSeriales(input: $input, condition: $condition) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecibaSerialesMP = /* GraphQL */ `
  mutation CreateRecibaSerialesMP(
    $input: CreateRecibaSerialesMPInput!
    $condition: ModelRecibaSerialesMPConditionInput
  ) {
    createRecibaSerialesMP(input: $input, condition: $condition) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecibaSerialesMP = /* GraphQL */ `
  mutation UpdateRecibaSerialesMP(
    $input: UpdateRecibaSerialesMPInput!
    $condition: ModelRecibaSerialesMPConditionInput
  ) {
    updateRecibaSerialesMP(input: $input, condition: $condition) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecibaSerialesMP = /* GraphQL */ `
  mutation DeleteRecibaSerialesMP(
    $input: DeleteRecibaSerialesMPInput!
    $condition: ModelRecibaSerialesMPConditionInput
  ) {
    deleteRecibaSerialesMP(input: $input, condition: $condition) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createAutorizaciones = /* GraphQL */ `
  mutation CreateAutorizaciones(
    $input: CreateAutorizacionesInput!
    $condition: ModelAutorizacionesConditionInput
  ) {
    createAutorizaciones(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateAutorizaciones = /* GraphQL */ `
  mutation UpdateAutorizaciones(
    $input: UpdateAutorizacionesInput!
    $condition: ModelAutorizacionesConditionInput
  ) {
    updateAutorizaciones(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteAutorizaciones = /* GraphQL */ `
  mutation DeleteAutorizaciones(
    $input: DeleteAutorizacionesInput!
    $condition: ModelAutorizacionesConditionInput
  ) {
    deleteAutorizaciones(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecuperacion = /* GraphQL */ `
  mutation CreateRecuperacion(
    $input: CreateRecuperacionInput!
    $condition: ModelRecuperacionConditionInput
  ) {
    createRecuperacion(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecuperacion = /* GraphQL */ `
  mutation UpdateRecuperacion(
    $input: UpdateRecuperacionInput!
    $condition: ModelRecuperacionConditionInput
  ) {
    updateRecuperacion(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecuperacion = /* GraphQL */ `
  mutation DeleteRecuperacion(
    $input: DeleteRecuperacionInput!
    $condition: ModelRecuperacionConditionInput
  ) {
    deleteRecuperacion(input: $input, condition: $condition) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaneacionBase = /* GraphQL */ `
  mutation CreatePlaneacionBase(
    $input: CreatePlaneacionBaseInput!
    $condition: ModelPlaneacionBaseConditionInput
  ) {
    createPlaneacionBase(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlaneacionBase = /* GraphQL */ `
  mutation UpdatePlaneacionBase(
    $input: UpdatePlaneacionBaseInput!
    $condition: ModelPlaneacionBaseConditionInput
  ) {
    updatePlaneacionBase(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlaneacionBase = /* GraphQL */ `
  mutation DeletePlaneacionBase(
    $input: DeletePlaneacionBaseInput!
    $condition: ModelPlaneacionBaseConditionInput
  ) {
    deletePlaneacionBase(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createADatosROperacion = /* GraphQL */ `
  mutation CreateADatosROperacion(
    $input: CreateADatosROperacionInput!
    $condition: ModelADatosROperacionConditionInput
  ) {
    createADatosROperacion(input: $input, condition: $condition) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateADatosROperacion = /* GraphQL */ `
  mutation UpdateADatosROperacion(
    $input: UpdateADatosROperacionInput!
    $condition: ModelADatosROperacionConditionInput
  ) {
    updateADatosROperacion(input: $input, condition: $condition) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteADatosROperacion = /* GraphQL */ `
  mutation DeleteADatosROperacion(
    $input: DeleteADatosROperacionInput!
    $condition: ModelADatosROperacionConditionInput
  ) {
    deleteADatosROperacion(input: $input, condition: $condition) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createResumenOperacion = /* GraphQL */ `
  mutation CreateResumenOperacion(
    $input: CreateResumenOperacionInput!
    $condition: ModelResumenOperacionConditionInput
  ) {
    createResumenOperacion(input: $input, condition: $condition) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateResumenOperacion = /* GraphQL */ `
  mutation UpdateResumenOperacion(
    $input: UpdateResumenOperacionInput!
    $condition: ModelResumenOperacionConditionInput
  ) {
    updateResumenOperacion(input: $input, condition: $condition) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteResumenOperacion = /* GraphQL */ `
  mutation DeleteResumenOperacion(
    $input: DeleteResumenOperacionInput!
    $condition: ModelResumenOperacionConditionInput
  ) {
    deleteResumenOperacion(input: $input, condition: $condition) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaneacionBaseGeneral = /* GraphQL */ `
  mutation CreatePlaneacionBaseGeneral(
    $input: CreatePlaneacionBaseGeneralInput!
    $condition: ModelPlaneacionBaseGeneralConditionInput
  ) {
    createPlaneacionBaseGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlaneacionBaseGeneral = /* GraphQL */ `
  mutation UpdatePlaneacionBaseGeneral(
    $input: UpdatePlaneacionBaseGeneralInput!
    $condition: ModelPlaneacionBaseGeneralConditionInput
  ) {
    updatePlaneacionBaseGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlaneacionBaseGeneral = /* GraphQL */ `
  mutation DeletePlaneacionBaseGeneral(
    $input: DeletePlaneacionBaseGeneralInput!
    $condition: ModelPlaneacionBaseGeneralConditionInput
  ) {
    deletePlaneacionBaseGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaneacion = /* GraphQL */ `
  mutation CreatePlaneacion(
    $input: CreatePlaneacionInput!
    $condition: ModelPlaneacionConditionInput
  ) {
    createPlaneacion(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlaneacion = /* GraphQL */ `
  mutation UpdatePlaneacion(
    $input: UpdatePlaneacionInput!
    $condition: ModelPlaneacionConditionInput
  ) {
    updatePlaneacion(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlaneacion = /* GraphQL */ `
  mutation DeletePlaneacion(
    $input: DeletePlaneacionInput!
    $condition: ModelPlaneacionConditionInput
  ) {
    deletePlaneacion(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaneacionGeneral = /* GraphQL */ `
  mutation CreatePlaneacionGeneral(
    $input: CreatePlaneacionGeneralInput!
    $condition: ModelPlaneacionGeneralConditionInput
  ) {
    createPlaneacionGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlaneacionGeneral = /* GraphQL */ `
  mutation UpdatePlaneacionGeneral(
    $input: UpdatePlaneacionGeneralInput!
    $condition: ModelPlaneacionGeneralConditionInput
  ) {
    updatePlaneacionGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlaneacionGeneral = /* GraphQL */ `
  mutation DeletePlaneacionGeneral(
    $input: DeletePlaneacionGeneralInput!
    $condition: ModelPlaneacionGeneralConditionInput
  ) {
    deletePlaneacionGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPProduccion = /* GraphQL */ `
  mutation CreatePProduccion(
    $input: CreatePProduccionInput!
    $condition: ModelPProduccionConditionInput
  ) {
    createPProduccion(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePProduccion = /* GraphQL */ `
  mutation UpdatePProduccion(
    $input: UpdatePProduccionInput!
    $condition: ModelPProduccionConditionInput
  ) {
    updatePProduccion(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePProduccion = /* GraphQL */ `
  mutation DeletePProduccion(
    $input: DeletePProduccionInput!
    $condition: ModelPProduccionConditionInput
  ) {
    deletePProduccion(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPProduccionGeneral = /* GraphQL */ `
  mutation CreatePProduccionGeneral(
    $input: CreatePProduccionGeneralInput!
    $condition: ModelPProduccionGeneralConditionInput
  ) {
    createPProduccionGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePProduccionGeneral = /* GraphQL */ `
  mutation UpdatePProduccionGeneral(
    $input: UpdatePProduccionGeneralInput!
    $condition: ModelPProduccionGeneralConditionInput
  ) {
    updatePProduccionGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePProduccionGeneral = /* GraphQL */ `
  mutation DeletePProduccionGeneral(
    $input: DeletePProduccionGeneralInput!
    $condition: ModelPProduccionGeneralConditionInput
  ) {
    deletePProduccionGeneral(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEmbarque = /* GraphQL */ `
  mutation CreateEmbarque(
    $input: CreateEmbarqueInput!
    $condition: ModelEmbarqueConditionInput
  ) {
    createEmbarque(input: $input, condition: $condition) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEmbarque = /* GraphQL */ `
  mutation UpdateEmbarque(
    $input: UpdateEmbarqueInput!
    $condition: ModelEmbarqueConditionInput
  ) {
    updateEmbarque(input: $input, condition: $condition) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEmbarque = /* GraphQL */ `
  mutation DeleteEmbarque(
    $input: DeleteEmbarqueInput!
    $condition: ModelEmbarqueConditionInput
  ) {
    deleteEmbarque(input: $input, condition: $condition) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createFacturaConceptoGeneral = /* GraphQL */ `
  mutation CreateFacturaConceptoGeneral(
    $input: CreateFacturaConceptoGeneralInput!
    $condition: ModelFacturaConceptoGeneralConditionInput
  ) {
    createFacturaConceptoGeneral(input: $input, condition: $condition) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateFacturaConceptoGeneral = /* GraphQL */ `
  mutation UpdateFacturaConceptoGeneral(
    $input: UpdateFacturaConceptoGeneralInput!
    $condition: ModelFacturaConceptoGeneralConditionInput
  ) {
    updateFacturaConceptoGeneral(input: $input, condition: $condition) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteFacturaConceptoGeneral = /* GraphQL */ `
  mutation DeleteFacturaConceptoGeneral(
    $input: DeleteFacturaConceptoGeneralInput!
    $condition: ModelFacturaConceptoGeneralConditionInput
  ) {
    deleteFacturaConceptoGeneral(input: $input, condition: $condition) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEmbarqueSeriales = /* GraphQL */ `
  mutation CreateEmbarqueSeriales(
    $input: CreateEmbarqueSerialesInput!
    $condition: ModelEmbarqueSerialesConditionInput
  ) {
    createEmbarqueSeriales(input: $input, condition: $condition) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEmbarqueSeriales = /* GraphQL */ `
  mutation UpdateEmbarqueSeriales(
    $input: UpdateEmbarqueSerialesInput!
    $condition: ModelEmbarqueSerialesConditionInput
  ) {
    updateEmbarqueSeriales(input: $input, condition: $condition) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEmbarqueSeriales = /* GraphQL */ `
  mutation DeleteEmbarqueSeriales(
    $input: DeleteEmbarqueSerialesInput!
    $condition: ModelEmbarqueSerialesConditionInput
  ) {
    deleteEmbarqueSeriales(input: $input, condition: $condition) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCotizacion = /* GraphQL */ `
  mutation CreateCotizacion(
    $input: CreateCotizacionInput!
    $condition: ModelCotizacionConditionInput
  ) {
    createCotizacion(input: $input, condition: $condition) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCotizacion = /* GraphQL */ `
  mutation UpdateCotizacion(
    $input: UpdateCotizacionInput!
    $condition: ModelCotizacionConditionInput
  ) {
    updateCotizacion(input: $input, condition: $condition) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCotizacion = /* GraphQL */ `
  mutation DeleteCotizacion(
    $input: DeleteCotizacionInput!
    $condition: ModelCotizacionConditionInput
  ) {
    deleteCotizacion(input: $input, condition: $condition) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCotizacionArea = /* GraphQL */ `
  mutation CreateCotizacionArea(
    $input: CreateCotizacionAreaInput!
    $condition: ModelCotizacionAreaConditionInput
  ) {
    createCotizacionArea(input: $input, condition: $condition) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCotizacionArea = /* GraphQL */ `
  mutation UpdateCotizacionArea(
    $input: UpdateCotizacionAreaInput!
    $condition: ModelCotizacionAreaConditionInput
  ) {
    updateCotizacionArea(input: $input, condition: $condition) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCotizacionArea = /* GraphQL */ `
  mutation DeleteCotizacionArea(
    $input: DeleteCotizacionAreaInput!
    $condition: ModelCotizacionAreaConditionInput
  ) {
    deleteCotizacionArea(input: $input, condition: $condition) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createEmbarqueUltimoNumero = /* GraphQL */ `
  mutation CreateEmbarqueUltimoNumero(
    $input: CreateEmbarqueUltimoNumeroInput!
    $condition: ModelEmbarqueUltimoNumeroConditionInput
  ) {
    createEmbarqueUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateEmbarqueUltimoNumero = /* GraphQL */ `
  mutation UpdateEmbarqueUltimoNumero(
    $input: UpdateEmbarqueUltimoNumeroInput!
    $condition: ModelEmbarqueUltimoNumeroConditionInput
  ) {
    updateEmbarqueUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteEmbarqueUltimoNumero = /* GraphQL */ `
  mutation DeleteEmbarqueUltimoNumero(
    $input: DeleteEmbarqueUltimoNumeroInput!
    $condition: ModelEmbarqueUltimoNumeroConditionInput
  ) {
    deleteEmbarqueUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPProduccionUltimoNumero = /* GraphQL */ `
  mutation CreatePProduccionUltimoNumero(
    $input: CreatePProduccionUltimoNumeroInput!
    $condition: ModelPProduccionUltimoNumeroConditionInput
  ) {
    createPProduccionUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePProduccionUltimoNumero = /* GraphQL */ `
  mutation UpdatePProduccionUltimoNumero(
    $input: UpdatePProduccionUltimoNumeroInput!
    $condition: ModelPProduccionUltimoNumeroConditionInput
  ) {
    updatePProduccionUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePProduccionUltimoNumero = /* GraphQL */ `
  mutation DeletePProduccionUltimoNumero(
    $input: DeletePProduccionUltimoNumeroInput!
    $condition: ModelPProduccionUltimoNumeroConditionInput
  ) {
    deletePProduccionUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaneacionBaseUltimoNumero = /* GraphQL */ `
  mutation CreatePlaneacionBaseUltimoNumero(
    $input: CreatePlaneacionBaseUltimoNumeroInput!
    $condition: ModelPlaneacionBaseUltimoNumeroConditionInput
  ) {
    createPlaneacionBaseUltimoNumero(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlaneacionBaseUltimoNumero = /* GraphQL */ `
  mutation UpdatePlaneacionBaseUltimoNumero(
    $input: UpdatePlaneacionBaseUltimoNumeroInput!
    $condition: ModelPlaneacionBaseUltimoNumeroConditionInput
  ) {
    updatePlaneacionBaseUltimoNumero(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlaneacionBaseUltimoNumero = /* GraphQL */ `
  mutation DeletePlaneacionBaseUltimoNumero(
    $input: DeletePlaneacionBaseUltimoNumeroInput!
    $condition: ModelPlaneacionBaseUltimoNumeroConditionInput
  ) {
    deletePlaneacionBaseUltimoNumero(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createPlaneacionUltimoNumero = /* GraphQL */ `
  mutation CreatePlaneacionUltimoNumero(
    $input: CreatePlaneacionUltimoNumeroInput!
    $condition: ModelPlaneacionUltimoNumeroConditionInput
  ) {
    createPlaneacionUltimoNumero(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updatePlaneacionUltimoNumero = /* GraphQL */ `
  mutation UpdatePlaneacionUltimoNumero(
    $input: UpdatePlaneacionUltimoNumeroInput!
    $condition: ModelPlaneacionUltimoNumeroConditionInput
  ) {
    updatePlaneacionUltimoNumero(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deletePlaneacionUltimoNumero = /* GraphQL */ `
  mutation DeletePlaneacionUltimoNumero(
    $input: DeletePlaneacionUltimoNumeroInput!
    $condition: ModelPlaneacionUltimoNumeroConditionInput
  ) {
    deletePlaneacionUltimoNumero(input: $input, condition: $condition) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createRecibaUltimoNumero = /* GraphQL */ `
  mutation CreateRecibaUltimoNumero(
    $input: CreateRecibaUltimoNumeroInput!
    $condition: ModelRecibaUltimoNumeroConditionInput
  ) {
    createRecibaUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateRecibaUltimoNumero = /* GraphQL */ `
  mutation UpdateRecibaUltimoNumero(
    $input: UpdateRecibaUltimoNumeroInput!
    $condition: ModelRecibaUltimoNumeroConditionInput
  ) {
    updateRecibaUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteRecibaUltimoNumero = /* GraphQL */ `
  mutation DeleteRecibaUltimoNumero(
    $input: DeleteRecibaUltimoNumeroInput!
    $condition: ModelRecibaUltimoNumeroConditionInput
  ) {
    deleteRecibaUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCotizacionUltimoNumero = /* GraphQL */ `
  mutation CreateCotizacionUltimoNumero(
    $input: CreateCotizacionUltimoNumeroInput!
    $condition: ModelCotizacionUltimoNumeroConditionInput
  ) {
    createCotizacionUltimoNumero(input: $input, condition: $condition) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCotizacionUltimoNumero = /* GraphQL */ `
  mutation UpdateCotizacionUltimoNumero(
    $input: UpdateCotizacionUltimoNumeroInput!
    $condition: ModelCotizacionUltimoNumeroConditionInput
  ) {
    updateCotizacionUltimoNumero(input: $input, condition: $condition) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCotizacionUltimoNumero = /* GraphQL */ `
  mutation DeleteCotizacionUltimoNumero(
    $input: DeleteCotizacionUltimoNumeroInput!
    $condition: ModelCotizacionUltimoNumeroConditionInput
  ) {
    deleteCotizacionUltimoNumero(input: $input, condition: $condition) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createTicketUltimoNumero = /* GraphQL */ `
  mutation CreateTicketUltimoNumero(
    $input: CreateTicketUltimoNumeroInput!
    $condition: ModelTicketUltimoNumeroConditionInput
  ) {
    createTicketUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateTicketUltimoNumero = /* GraphQL */ `
  mutation UpdateTicketUltimoNumero(
    $input: UpdateTicketUltimoNumeroInput!
    $condition: ModelTicketUltimoNumeroConditionInput
  ) {
    updateTicketUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteTicketUltimoNumero = /* GraphQL */ `
  mutation DeleteTicketUltimoNumero(
    $input: DeleteTicketUltimoNumeroInput!
    $condition: ModelTicketUltimoNumeroConditionInput
  ) {
    deleteTicketUltimoNumero(input: $input, condition: $condition) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createUsuarios = /* GraphQL */ `
  mutation CreateUsuarios(
    $input: CreateUsuariosInput!
    $condition: ModelUsuariosConditionInput
  ) {
    createUsuarios(input: $input, condition: $condition) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUsuarios = /* GraphQL */ `
  mutation UpdateUsuarios(
    $input: UpdateUsuariosInput!
    $condition: ModelUsuariosConditionInput
  ) {
    updateUsuarios(input: $input, condition: $condition) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUsuarios = /* GraphQL */ `
  mutation DeleteUsuarios(
    $input: DeleteUsuariosInput!
    $condition: ModelUsuariosConditionInput
  ) {
    deleteUsuarios(input: $input, condition: $condition) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createLocacion = /* GraphQL */ `
  mutation CreateLocacion(
    $input: CreateLocacionInput!
    $condition: ModelLocacionConditionInput
  ) {
    createLocacion(input: $input, condition: $condition) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateLocacion = /* GraphQL */ `
  mutation UpdateLocacion(
    $input: UpdateLocacionInput!
    $condition: ModelLocacionConditionInput
  ) {
    updateLocacion(input: $input, condition: $condition) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteLocacion = /* GraphQL */ `
  mutation DeleteLocacion(
    $input: DeleteLocacionInput!
    $condition: ModelLocacionConditionInput
  ) {
    deleteLocacion(input: $input, condition: $condition) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createCambios = /* GraphQL */ `
  mutation CreateCambios(
    $input: CreateCambiosInput!
    $condition: ModelCambiosConditionInput
  ) {
    createCambios(input: $input, condition: $condition) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateCambios = /* GraphQL */ `
  mutation UpdateCambios(
    $input: UpdateCambiosInput!
    $condition: ModelCambiosConditionInput
  ) {
    updateCambios(input: $input, condition: $condition) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteCambios = /* GraphQL */ `
  mutation DeleteCambios(
    $input: DeleteCambiosInput!
    $condition: ModelCambiosConditionInput
  ) {
    deleteCambios(input: $input, condition: $condition) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
